import { useEffect } from 'react'

import { useFormContext, useWatch } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface ISINFieldProps {
  placeholder?: string
}

export const ISINField: React.FC<ISINFieldProps> = ({ placeholder }) => {
  const { control, register, setValue } = useFormContext<{ isin: string }>()
  const [isin] = useWatch({ control, name: ['isin'] })

  useEffect(() => {
    if (isin === '') {
      setValue('isin', null as unknown as string, { shouldValidate: true })
    }
  }, [isin])

  return (
    <FormField
      name="isin"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>ISIN</FormLabel>
              <FormError />
            </div>
            <Input {...register('isin')} placeholder={placeholder ?? 'Enter an ISIN'} />
          </FormItem>
        )
      }}
    />
  )
}
